export default "__VITE_ASSET__D4yC1_TV__"